<div class="main">

    <div id="root">
      <!-- Header needed -->
      <app-header></app-header>
      <!-- body -->
      <router-outlet></router-outlet>
      <!-- Footer  -->
      <app-footer></app-footer>
    </div>
  </div>